import Vue from 'vue'
import http from '@/fetch/http'
import * as types  from '@/vuex/types'
import util from '@/utils'

const state = {

}

const actions = {

}

const getters = {}

const mutations = {
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/teachCourse.js